import api from "./api";
import getBasename from "../../../ui/getBasename";

const users = {}
/*
Функция отправляет данные для входа на сервер и возвращает Promise с ответом с севера
*/
users.login = function(credentials){
  return api.post(getBasename() + '/api/users/login', credentials)
}
/*
  Функция отправляет на сервер запрос на выход и возвращает Promise с результатом: ok - успешное завершение
*/
users.logout = function(){
  return api.post(getBasename() + '/api/users/logout')
}
/*
  Функция отправляет на сервер запрос на добавление нового пользователя
*/
users.save = function save(credentials){
  return api.post(getBasename() + '/api/users/save', credentials)
}

users.update = function update(credentials, userId){
  let request = '/api/users/' + userId + '/update';
  return api.post(request, {...credentials, id: userId});
}

users.delete = function deleteUser(userId, token = ""){
  let request = '/api/users/' + userId + '/delete';
  return api.post(request, {});
}

users.restore = function restoreUser(userId){
  let request = '/api/users/' + userId + '/restore';
  return api.post(request, {});
}

users.check = function(credentials){
  return api.post('/api/users/check/login', credentials);
}

export default users;
